import { ReviewDialogs } from "@components/QaReview/components/ReviewDialogs";
import { ReviewPanel } from "@components/QaReview/components/ReviewPanel";
import { SuggestionCardSkeletons } from "@components/QaReview/components/ReviewStates";
import { useQaScanState } from "@components/QaReview/hooks/useQaScanState";
import { useToFixReviewers } from "@components/QaReview/hooks/useToFixReviewers";

interface ReviewColumnProps {
  scrollRef: React.RefObject<HTMLDivElement | null>;
  /** The column's outer box, which the page's review bar centers on. */
  containerRef?: React.Ref<HTMLDivElement>;
  containerId: string;
  panelClassName: string;
}

/**
 * The Checkpoint column: the cards beside their fields. The page's review bar walks them, and Quality
 * Review's checking and failed states live in it, so Team Review cards stay listed through both; while it
 * checks, one skeleton card holds the top of the stack where its flags will land. The author's to-fix cards
 * pin above the stack too.
 */
export const ReviewColumn: React.FC<ReviewColumnProps> = ({ scrollRef, containerRef, containerId, panelClassName }) => {
  const { isChecking } = useQaScanState();
  const toFixReviewers = useToFixReviewers();

  return (
    <div ref={containerRef} data-review-column>
      <div ref={scrollRef as React.RefObject<HTMLDivElement>} className={panelClassName}>
        <ReviewPanel
          scrollParentRef={scrollRef}
          containerId={containerId}
          qaStatus={isChecking ? <SuggestionCardSkeletons count={1} /> : null}
          toFixReviewers={toFixReviewers}
        />
      </div>
      {/* Room for the bar after the last card; it also lengthens the page, so the report's end clears it too. */}
      <div
        aria-hidden
        data-testid="review-bar-space"
        className="h-[calc(var(--review-bar-offset,0px)+2rem)] shrink-0"
      />
      <ReviewDialogs />
    </div>
  );
};
